export default __webpack_public_path__ + "img/homepage-mobile.6052f8cb.svg";